import * as angular from 'angular';

import { ComponentDefinition } from '../../models/index';

class MoreLessController implements angular.IComponentController {
    
    readonly hasLess: boolean;
    readonly hasMore: boolean;
    readonly less: () => any;
    readonly lessText: string;
    readonly more: () => any;
    readonly moreText: string;

    static $inject = [];
}

export const wtMoreLess: ComponentDefinition = {
    componentId: 'wtMoreLess',
    controller: MoreLessController,
    template: require('./moreLess.component.html'),
    controllerAs: 'vm',
    bindings: {
        hasMore: '<?',
        more: '&',
        moreText: '@?',
        hasLess: '<?',
        less: '&',
        lessText: '@?'
    }
};
